import _JSXStyle from "styled-jsx/style";
import PropTypes from 'prop-types';
import React from 'react';
import { backgroundColor, borderColor, borderRadius } from './common/index.js';
export const LeftSide = _ref => {
  let {
    children,
    dataTest,
    width
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest,
    className: _JSXStyle.dynamic([["4143353612", [backgroundColor, borderRadius, borderColor, width]]])
  }, children,
  /**
   * Flex basis 0px to make sure right and left side
   * always have the same width
   */
  '', /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "4143353612",
    dynamic: [backgroundColor, borderRadius, borderColor, width]
  }, ["div.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;background-color:".concat(backgroundColor, ";border-radius:").concat(borderRadius, ";border:1px solid ").concat(borderColor, ";min-height:240px;max-width:100%;width:").concat(width, ";}")]));
};
LeftSide.propTypes = {
  width: PropTypes.string.isRequired,
  children: PropTypes.node,
  dataTest: PropTypes.string
};